import React from "react";
import { VisuallyHidden } from "react-aria";
import { t } from "ttag";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Themed } from "../../../styles/themes";
import { Clickable } from "../../Clickables";
import { useProductContext } from "../ProductContext/ProductContext";
import { Contribution } from "../engine";
import { JOINING_KIT_SKU } from "../format";
import { SkuLine } from "./SkuLine";

import styles from "./ContributionCard.module.scss";

export type ContributionCardProps = {
    contribution: Contribution;
    onRemove?: () => void;
    hasJoiningKit?: boolean;
    mode: "landing" | "miniCart" | "confirmation";
};

export const ContributionCard = ({
    contribution,
    onRemove,
    hasJoiningKit = false,
    mode,
}: ContributionCardProps) => {
    const { getProduct } = useProductContext();
    const product = getProduct(contribution.mainSku);
    const image = product.image;
    return (
        <Themed theme="white" className={styles[mode]}>
            <ImageChooserBlock
                value={image}
                attrs={{ className: styles.picture }}
                imageAttrs={{ className: styles.image }}
            />
            <div className={styles.cardContent}>
                <SkuLine sku={contribution.mainSku} />
                {contribution.accessorySkus.map((sku) => (
                    <SkuLine key={sku} sku={sku} />
                ))}
                {hasJoiningKit && <SkuLine sku={JOINING_KIT_SKU} />}
                {onRemove && (
                    <Clickable
                        onClick={onRemove}
                        className={styles.removeButton}
                    >
                        <span aria-hidden="true">{t`Remove`}</span>
                        <VisuallyHidden>{t`Remove ${product.name}`}</VisuallyHidden>
                    </Clickable>
                )}
            </div>
        </Themed>
    );
};
